<template>
    <v-layout justify-center>
        <v-flex xs12>
            <v-form
                    v-model="valid"
                    row
                    justify-center>
                <v-layout wrap>

                    <v-flex xs12  text-left pa-1 :class="[{'sm6': requested('birth_date')}]">
                        <v-text-field
                                v-model="patientDNI"
                                label="RUT"
                                clearable
                                :error-messages="error('dni')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 text-left pa-1 v-if="requested('birth_date')">
                        <birth-date-picker
                                label="Fecha de nacimiento"
                                :error-messages="error('birth_date')"
                                :value="birth_date"
                                @change="onBirthDateChange"
                                ref="datePicker" />

                    </v-flex>

                    <v-flex xs12 v-if="requested('first_name')" pa-1>
                        <v-text-field
                                autofocus
                                v-model="first_name"
                                label="Nombre"
                                :error-messages="error('first_name')"
                                clearable
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('last_name')">
                        <v-text-field
                                v-model="last_name"
                                label="Apellido Paterno"
                                clearable
                                :error-messages="error('last_name')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('mother_last_name')">
                        <v-text-field
                                v-model="mother_last_name"
                                label="Apellido Materno"
                                clearable
                                :error-messages="error('mother_last_name')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 pa-1 v-if="requested('occupation')">
                        <occupation-picker
                                ref="occupationPicker"
                                :provider-id="providerId"
                                :error-messages="error('occupation')"
                                v-on:change="onOccupationSelect"
                                :value="occupation || null"
                        />
                    </v-flex>

                    <v-flex xs12 md8 pa-1 v-if="requested('address')">
                        <location-picker
                            ref="locationPicker"
                            @change="onLocationSelect"
                            :default-value="defaultAddress"
                            :outline="false"
                            :hide-details="false"
                            :text-limit="100"
                            placeholder=""
                            prepend-icon=""
                            :error-messages="error('address')"
                        />
                    </v-flex>

                    <v-flex xs12 md4 pa-1 v-if="requested('address')">
                        <v-text-field
                                v-model="addressLine1"
                                label="Casa/Depto./Local"
                                clearable
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1  v-if="requested('email')">
                        <v-text-field
                                v-model="email"
                                label="E-mail"
                                clearable
                                :error-messages="error('email')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('phone1')">
                        <v-text-field
                                prefix="(+56)"
                                v-model="phone1"
                                mask="# #### ####"
                                label="Teléfono (Movil)"
                                clearable
                                :error-messages="error('phone1')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('phone2')">
                        <v-text-field
                                prefix="(+56)"
                                v-model="phone2"
                                mask="# #### ####"
                                label="Teléfono (Fijo)"
                                clearable
                                :error-messages="error('phone2')"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('insurance_company')">
                        <insurance-company-selector
                                :value="insurance_company"
                                :onChange="onInsuranceCompanyChange"
                                :error-messages="error('insurance_company')"
                        />
                    </v-flex>

                    <v-flex xs12 sm6 pa-1 v-if="requested('gender')">
                        <v-radio-group v-model="gender" row >
                            <v-radio label="Hombre" value="m"></v-radio>
                            <v-radio label="Mujer" value="f"></v-radio>
                            <v-radio label="Otro" value="o"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
            </v-form>

        </v-flex>





    </v-layout>
</template>

<script>

    import LocationPicker from '../../../components/common/LocationPicker'
    import KimsaLocationPicker from '../../../components/common/KimsaLocationPicker'
    import OccupationPicker from '../../../components/occupations/OccupationPicker'
    import InsuranceCompanySelector from '../../../components/insurance_companies/InsuranceCompanySelector'
    import DialogDatePicker from '../../../components/common/DialogDatePicker'
    import  BirthDatePicker from '../../../components/common/BirthDatePicker'

    import {rutValidator, rutFormat} from '../../../utils/Common'

    import { mapState, mapMutations } from 'vuex'

    export default{
        props: ['value', 'requiredFields', 'requestedFields', 'providerId'],
        components: {
            InsuranceCompanySelector,
            KimsaLocationPicker,
            OccupationPicker,
            DialogDatePicker,
            BirthDatePicker,
            LocationPicker
        },
        mounted(){
             this.setDefault()
        },
        data(vm){
            return {
                address: '',
                addressLine1: '',
                addressLatitude: '',
                addressLongitude: '',
                first_name: '',
                phone1: '',
                phone2: '',
                birth_date: '',
                gender: 'm',
                last_name: '',
                mother_last_name: '',
                occupation: null,
                email: '',
                patientDNI: '',
                insurance_company: null,

                valid: false,

                rutRules: [
                    rutValidator
                ],
                phoneRules: [
                    v => v.length === 0 || /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
                ],
                phone2Rules: [
                    v => /[1-9]\s?[0-9]{4}\s?[0-9]{3,4}/.test(v) || 'Teléfono inválido'
                ],
                requiredEmailRules: [
                    v => !v || /.+@.+/.test(v) || 'E-mail inválido'
                ],
                addressRules: [
                    v =>  !!v || 'La redireccion es obligatoria'
                ],
                emailRules: [
                    v => /(^$|.+@.+)/.test(v) || 'E-mail inválido'
                ],
                passwordRules: [
                    v => !!v || 'Contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ],
                firstNameRules: [
                    v => v.length >= 2 || 'Debe tener al menos 2 caracteres'
                ],
                lastNameRules: [
                    v => v.length >= 2 || 'Debe tener al menos 2 caracteres'
                ]

            }
        },
        watch:{
            patientDNI(newValue){
                this.patientDNI = rutFormat(newValue)
            },
            valid(val){
                this.$emit('update:valid', val)
            },
            value(val){
                this.setDefault()
            }
        },
        computed:{
            ...mapState(['loader', 'currentBranchOffice']),
            requiredClientFields(){

                var vm = this
                if(vm.requiredFields) return vm.requiredFields

                return [
                    'dni',
                    'first_name',
                    'last_name',
                    'phone1',
                    'insurance_company',
                    'birth_date',
                ]

            },
            requestedClientFields(){

                var vm = this
                if(vm.requestedFields) return vm.requestedFields

                return [
                    'dni',
                    'birth_date',
                    'first_name',
                    'last_name',
                    'mother_last_name',
                    'email',
                    'occupation',
                    'address',
                    'phone1',
                    'phone2',
                    'insurance_company',
                ]

            },
            defaultAddress(){
                var vm = this

                if(!vm.value || !vm.value.address) return null
                const defaultValue = JSON.parse(JSON.stringify(vm.value))

                return {
                    text: defaultValue.address,
                    location: !!defaultValue.address_longitude && !!defaultValue.address_longitude ? {
                        lng: defaultValue.address_longitude,
                        lat: defaultValue.address_latitude
                    } : null
                }
            },
            mapTokens(){
                return {
                    google: process.env.VUE_APP_GMAPS_API_KEY,
                    mapBox: process.env.VUE_APP_MAPBOX_TOKEN
                }
            },
            center(){
                var vm = this
                var branchDefault = vm.currentBranchOffice ?
                        [vm.currentBranchOffice.longitude, vm.currentBranchOffice.latitude] :
                        [ -71.24739, -32.87996809999999]

                return vm.value && vm.value.address_longitude  && vm.value.address_latitude ?
                        [vm.value.address_longitude, vm.value.address_latitude] : branchDefault

            }
        },
        methods:{

            onBirthDateChange(val){
                this.birth_date = val
            },

            error(field = ''){

                var  vm = this

                switch (field){

                    case 'dni':
                        return vm.validateDNI();
                        break;
                    case 'phone1':
                        return vm.validatePhone(1);
                        break;
                    case 'phone2':
                        return vm.validatePhone(2);
                        break;
                    case 'email':
                        return vm.validateEmail();
                        break;
                    default:
                        return vm.validateGenericField(field)
                        break;

                }

            },
            validateEmail(){

                var vm =  this
                const isRequired = vm.required('email')
                const value = vm.email
                if(isRequired && !value){
                    return 'Este campo es obligatorio'
                }

                return /(^$|.+@.+\.\w+)/.test(value) ? '' : 'Formato incorrecto'

            },
            validatePhone(type= 1){ // 1: mobile, 2:local

                var vm =  this
                const typeString = type === 1 ? 'phone1' : 'phone2'
                const isRequired = vm.required(typeString)
                const value = vm.$data[typeString]
                if(isRequired && !value){
                    return 'Este campo es obligatorio'
                }

                var regex = type === 1 ? new RegExp('^[1-9]\s?[0-9]{4}\s?[0-9]{4}$') :
                        new RegExp('^[1-9]\s?[0-9]{4}\s?[0-9]{3,4}$')

                return regex.test(value) || value === '' ? '' : 'Formato incorrecto'

            },
            validateGenericField(field){

                var vm = this
                const value = vm.$data[field]
                const isRequired = vm.required(field)

                if(isRequired && !value){
                    return 'Este campo es obligatorio'
                }

                return ''

            },
            validateDNI(){

                var vm = this
                var isRequired = vm.required('dni')

                if(isRequired && !vm.patientDNI){
                    return 'RUT es obligatorio'
                }

                const rutValidation = rutValidator(vm.patientDNI)
                if(rutValidation !== true){
                    return rutValidation
                }

                return ''

            },

            setDefault(){
                var vm = this
                if(!vm.value) return



                vm.patientDNI = rutFormat(vm.value.dni) || ''
                vm.first_name = vm.value.first_name || ''
                vm.last_name = vm.value.last_name || ''
                vm.mother_last_name = vm.value.mother_last_name || ''
                vm.phone1 = vm.value.phone1 || ''
                vm.phone2 = vm.value.phone2 || ''
                vm.gender = vm.value.gender || 'm'
                vm.email = vm.value.email || ''
                vm.occupation = vm.value.occupation || null
                vm.address = vm.value.address || ''
                vm.addressLine1 = vm.value.address_line1 || ''
                vm.addressLongitude = vm.value.address_longitude || ''
                vm.addressLatitude = vm.value.address_latitude || ''
                vm.insurance_company = vm.value.insurance_company || null
                vm.birth_date = vm.value.birth_date || ''
            },
            reset(){
                var vm = this

                vm.patientDNI = ''
                vm.first_name = ''
                vm.last_name = ''
                vm.mother_last_name = ''
                vm.phone1 = ''
                vm.phone2 = ''
                vm.gender = 'm'
                vm.email = ''
                vm.address = ''
                vm.addressLine1 = ''
                vm.addressLongitude = ''
                vm.addressLatitude = ''
                vm.$refs.occupationPicker.clearSearch()
                vm.$refs.locationPicker.clearSearch()
                vm.insurance_company = null

            },
            required(field = ''){

                var vm = this
                return vm.requiredClientFields.includes(field)

            },
            requested(field = ''){

                var vm = this
                return vm.requestedClientFields.includes(field)

            },
            onOccupationSelect(occupation){

                this.occupation = occupation
            },
            showLocationPicker(){
                this.$refs.locationPicker.show()
            },
            hideLocationPicker(){
                this.$refs.locationPicker.hide()
            },
            onLocationSelect(location){
                var vm = this



                if(!location){
                    vm.address = ''
                    vm.addressLongitude = ''
                    vm.addressLatitude = ''
                    return
                }

                vm.address = location.address.full

                vm.addressLongitude = location.location && location.location.lng || ''
                vm.addressLatitude = location.location && location.location.lat || ''


            },
            onInsuranceCompanyChange(val){

                var vm = this
                vm.insurance_company = val
            },
            getUserData(){
                var vm = this
                let user = {
                    first_name: vm.first_name,
                    last_name: vm.last_name,
                    mother_last_name: vm.mother_last_name,
                    dni: vm.patientDNI,
                    birth_date: vm.birth_date,
                    gender: vm.gender,
                    phone1: vm.phone1,
                    phone2: vm.phone2,
                }

                user.address = vm.address
                user.address_line1 = vm.addressLine1 || ''
                user.address_longitude = vm.addressLongitude
                user.address_latitude = vm.addressLatitude

                if(vm.occupation){
                    user.occupation_id = vm.occupation.id
                }

                if(vm.insurance_company){
                    user.insurance_company_id = vm.insurance_company.id
                }

                if(vm.email){
                    user.email = vm.email
                }



                return user

            }
        }

    }

</script>
